import normalizeUtil from '~APP_UTIL/normalize';
import actionTypes from './actionTypes';

export const DEFAULT_ADMIN_USERS_STATE = {
  adminUsers: null
};

const { arrayToIndexed } = normalizeUtil;

const adminUsersReducer = (state = DEFAULT_ADMIN_USERS_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.FETCH_ADMIN_USERS: {
      const adminUsersArray = payload;
      const indexedAdminUsers = arrayToIndexed({ array: adminUsersArray, indexer: 'account' });

      return {
        ...state,
        adminUsers: indexedAdminUsers
      };
    }

    default:
      return state;
  }
};

export default adminUsersReducer;
